import { Endpoint } from '@business/api/endpoint';
import {
  ProposalTemplateLibraryItemResponse,
  ProposalTemplateResponse,
  ProposalTemplateId,
  ProposalTemplateFolderId,
  ProposalTemplateStatus,
  CopyTemplateRequest,
  BlockTemplateResponse,
} from '@business/entities/proposal';

export function getItem(id: string, type: string, isPublic = true) {
  const prefix = isPublic ? 'public/' : '';
  if (type == 'template') {
    return Endpoint.get<ProposalTemplateLibraryItemResponse>(`@gc/${prefix}proposal-template/item/${id}`);
  } else {
    return Endpoint.get<ProposalTemplateLibraryItemResponse>(`@gc/proposal-template-admin/item/${id}`);
  }
}

export function fetchTemplates(full = false, status = 'active', folderId?: ProposalTemplateFolderId) {
  return Endpoint.get<ProposalTemplateResponse[]>(`@gc/proposal-template`, { params: { full, status, folderId: folderId || '0' } });
}

export function fetchTemplate(id: ProposalTemplateId) {
  return Endpoint.get<ProposalTemplateResponse>(`@gc/proposal-template/item/${id}`);
}

export function getProjectListTemplate() {
  return Endpoint.get<ProposalTemplateResponse>(`@gc/proposal-template/project-list`);
}

export function createTemplate(data: Partial<ProposalTemplateResponse> & { libraryId?: string }) {
  return Endpoint.post<ProposalTemplateResponse>(`@gc/proposal-template`, { data });
}

export function updateTemplate(id: ProposalTemplateId, data: Partial<ProposalTemplateResponse>) {
  return Endpoint.patch<ProposalTemplateResponse>(`@gc/proposal-template/${id}`, { data });
}

export function deleteTemplate(id: ProposalTemplateId) {
  return Endpoint.delete<ProposalTemplateResponse>(`@gc/proposal-template/${id}`);
}

export function updateFormData(id: string, data: string) {
  return Endpoint.post<ProposalTemplateResponse>(`@gc/proposal-template/update-form-data/${id}`, { data: { data } });
}

export function duplicateTemplate(id: ProposalTemplateId, name: string) {
  return Endpoint.post<ProposalTemplateResponse>(`@gc/proposal-template/duplicate/${id}`, { data: { name } });
}

export function moveTemplate(id: ProposalTemplateId, folderId: ProposalTemplateFolderId) {
  return Endpoint.post<ProposalTemplateResponse>(`@gc/proposal-template/move/${id}`, { data: { folderId } });
}

export function changeStatus(id: ProposalTemplateId, status: ProposalTemplateStatus) {
  return Endpoint.post<ProposalTemplateResponse>(`@gc/proposal-template/status/${id}`, { data: { status } });
}

export function copyBlockTemplate(data: CopyTemplateRequest) {
  return Endpoint.post<void>(`@gc/proposal-template/copy-template`, { data });
}

export function fetchBlockTemplates(type: string) {
  return Endpoint.get<BlockTemplateResponse[]>(`@gc/proposal-template/block-templates`, { params: { type } });
}

export function deleteBlockTemplate(id: string) {
  return Endpoint.delete<void>(`@gc/proposal-template/block-template/${id}`);
}
